export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14151.f1e7ae91.jpg";